var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconHistoryActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-80 -8)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 6,
    transform: "translate(80 8)",
    fill: "#fff",
    opacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1.5,15h24",
    transform: "translate(90.5 7)",
    fill: "none",
    stroke: "#171A20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5,15h24",
    transform: "translate(90.5 17)",
    fill: "none",
    stroke: "#171A20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5,15h24",
    transform: "translate(90.5 27)",
    fill: "none",
    stroke: "#171A20",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHistoryActive);
export default __webpack_public_path__ + "static/media/icon-history-active.f6186a1d.svg";
export { ForwardRef as ReactComponent };